import React, {PureComponent} from 'react';
import { Link } from 'react-router-dom';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Table,
} from 'reactstrap';

import './styles.css';
import axios from "axios";
import _ from 'lodash';
import Util from '../../Common/util';
import API from '../../Common/api';

class RegisterPhoto extends PureComponent {
  

  constructor(props) {
    /*var today = new Date(),
            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();*/

  var tempDate = new Date();
  var date = tempDate.getFullYear() + '-' + (tempDate.getMonth()+1) + '-' + tempDate.getDate() +' '+ tempDate.getHours()+':'+ tempDate.getMinutes()+':'+ tempDate.getSeconds();
  const currDate = "Current Date= "+date;
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.prinData = this.prinData.bind(this);
    this.state = {
      showPassword: false,
      showPrintData: [],
      date: currDate
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  componentDidMount(){
   var printDetail_data = localStorage.getItem('printData');
    var printDetails = JSON.parse(printDetail_data);
   /* console.log(printDetail_data);*/
    /*this.setState({
      showPrintData: printDetails
    })*/

    this.state.showPrintData.push(printDetails);
    
    

    setTimeout(this.prinData ,1100 );

    /*if (window.location.href="/putaway/printPutaway") {
          window.location.reload();
        }*/
   
  }

  prinData(){
   /* for (var i = 0; i < this.state.printDetails.length; i++) {*/
      window.print();
      
    /*}*/

    
  }

  onLogin(){
    const payload = {
    
    };
  
  
  API.post('/auth/oauth2/login', { param: payload })
       
      .then((response) =>  {

        console.log(response.data.login);
        if (response.data.login === false) {
          window.location.href = response.data.url;
        }

      })
      .catch(function (error) {
        
        
        
      });

  }




  render() {
    const { handleSubmit } = this.props;
    //   const { showPassword } = this.state;
    const arrData= JSON.parse(localStorage.getItem("printData"));
    const arrayValue= [];
    arrayValue.push(arrData);
    console.log(arrayValue);
    console.log(arrayValue.sort());




    

    return (






    <div className="print_table" style={{padding: 15}}>


    {
                       
          arrayValue.map((item) => (
            _.map(item, (value, key) => (
              <div style={{width: '100%'}}>
                <div className="separater" style={{marginBottom: 20, borderBottomWidth: 1}}>
                  <h5 style={{width: '50%', float: 'left', marginBottom: 15}}> <span style={{fontWeight: 'bold'}}> User Name: </span> <span> {key} </span> </h5>
                  <h5 style={{width: '50%', float: 'left', textAlign: 'right', marginBottom: 15}}> <span style={{fontWeight: 'bold'}}> Date: </span> <span> {this.state.date} </span></h5>
                  <h5 style={{width: '50%', float: 'left', marginBottom: 15}}> <span style={{fontWeight: 'bold'}}> PTL ID: </span> <span> {value[0].ptlId} / </span> <span style={{fontWeight: 'bold'}}> Pick Type: </span> <span> {value[0].pickType} </span> </h5>
                  <Table responsive className="table table--bordered" style={{marginBottom: 50}}>
                     <thead style={{background: '#ccc'}}>
                      <tr>
                        <th>BIN Id</th>
                        <th>LB SKU ID</th>                           
                        <th> LB SKU Product Name </th>
                        <th> CBU </th>
                        <th> PKD </th>
                        <th> MRP </th>
                        <th> UPC </th>
                        <th> Recieved ICLD Quantity </th>
                        <th> Tester Quantity </th>
                        <th> Loose Quantity </th>
                        <th> Crate ID </th>
                        <th> Zone Name </th>
                        


                        
                      </tr>
                    </thead>
                    <tbody>
                      {value.map(insideItem => (
                        <tr>
                          <td>{insideItem.binId}</td>
                          <td>{insideItem.lbSkuId} </td>
                          <td>{insideItem.lbSkuProductName} </td>
                          <td>{insideItem.cbu} </td>
                          <td> {insideItem.pkd} </td>
                          <td> {insideItem.mrp} </td>
                          <td> {insideItem.upc} </td>
                          <td> {insideItem.receivedIcldQty} </td>
                          <td> {insideItem.testerQty} </td>
                          <td> {insideItem.looseQuantity} </td>
                         
                          <td> {insideItem.crateId}</td>
                          <td> {insideItem.zoneName}</td>
                        </tr>
                      ))}

                    </tbody>
              
                  </Table>
                  

                </div>

                <div className="page-break"> </div>

                
                
              </div>

            ))
          ))
        }




</div>

)
}

}

export default RegisterPhoto;
